import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function ListToggleArrow({ isOpen }: Props) {
  return isOpen ? (
    <svg
      className={styles.listToggleArrow}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <rect width="18" height="18" rx="5" fill="#C2D9F3" />
      <path
        d="M7.23,14.625H.556A.543.543,0,0,0,0,15.154v.529a.543.543,0,0,0,.556.529H7.23a.543.543,0,0,0,.556-.529v-.529A.543.543,0,0,0,7.23,14.625Z"
        transform="translate(5.107 -6.418)"
        fill="#0C3343"
      />
    </svg>
  ) : (
    <svg
      className={styles.listToggleArrow}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <rect width="18" height="18" rx="5" fill="#C2D9F3" />
      <path
        d="M7.23,5.309h-2.5v-2.5a.556.556,0,0,0-.556-.556H3.615a.556.556,0,0,0-.556.556v2.5H.556A.556.556,0,0,0,0,5.865v.556a.556.556,0,0,0,.556.556h2.5v2.5a.556.556,0,0,0,.556.556h.556a.556.556,0,0,0,.556-.556v-2.5h2.5a.556.556,0,0,0,.556-.556V5.865A.556.556,0,0,0,7.23,5.309Z"
        transform="translate(5.107 2.857)"
        fill="#0C3343"
      />
    </svg>
  );
}

export { ListToggleArrow };
